<template>
  <button class="button" :class="getType(type)">{{value}}</button>
</template>

<script>
export default {
  name: 'Button',
  props: {
    value: String,
    type: String,
  },
  methods: {
    getType() {
      return this.type === 'primary' ? 'button--ios' : 'button--mac';
    },
  },
};
</script>

<style lang="scss" scoped>
// $breakpoints
$desktop-media-1: 50em;

.button {
  width: 100%;
  color: var(--white);
  font-size: var(--fs-h4);
  text-transform: none;
  font-weight: var(--fw-bold);
  outline: none;

  @media (min-width: $desktop-media-1) {
    width: max-content;
  }

  &--ios {
    background: var(--strong-cyan);
    box-shadow: 0 3px 0 0  var(--strong-dark-cyan), 0 3px 10px 0  var(--strong-cyan);
    &:hover, &:focus {
      box-shadow: 0 3px 0 0  var(--strong-dark-cyan), 0 0 0 0  var(--strong-cyan);
      border: 2px solid var(--strong-cyan);
      opacity: 0.7;
    }
  }
  &--mac {
    background: var(--light-blue);
    box-shadow: 0 3px 0 0  var(--light-dark-blue), 0 3px 10px 0  var(--light-blue);;
    &:hover, &:focus {
      box-shadow: 0 3px 0 0  var(--light-dark-blue), 0 0 0 0  var(--light-blue);
      border: 2px solid var(--light-blue);
      opacity: 0.7;
    }
  }
}
</style>
